module.exports = __webpack_public_path__ + "img/solution1.4cd8b8fb.png";